import React from 'react';

const ChequeBookIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <g clip-path="url(#clip0_13_19170)">
                <path d="M6.10107 15.8528H40V35.5314H6.10107V15.8528Z" fill="#EBF0F3" />
                <path d="M6.10107 21.6201H40V32.751H6.10107V21.6201Z" fill="#44C4A1" />
                <path d="M15.3929 33.7302H30.707V34.3464H15.3929V33.7302ZM12.5164 19.4373H24.291V20.0535H12.5164V19.4373ZM12.5164 17.5903H20.799V18.2065H12.5164V17.5903Z" fill="#64798A" />
                <path d="M10.7549 16.5696H8.4229L7.25684 18.5892L8.4229 20.6088H10.7549L11.921 18.5892L10.7549 16.5696Z" fill="#E56353" />
                <path d="M28.3574 17.8782H29.7703V20.0531H28.3574V17.8782ZM29.9566 17.8782H31.3695V20.0531H29.9566V17.8782ZM31.5574 17.8782H32.9702V20.0531H31.5574V17.8782ZM33.1531 17.8782H34.566V20.0531H33.1531V17.8782ZM34.7531 17.8782H36.1659V20.0531H34.7531V17.8782ZM36.353 17.8782H37.7659V20.0531H36.353V17.8782Z" fill="#D5D6DB" />
                <path d="M7.79565 24.0559H26.8538V24.6721H7.79565V24.0559ZM7.79565 26.8941H26.8538V27.5103H7.79565V26.8941ZM29.4075 29.6982H38.3047V30.3144H29.4075V29.6982ZM29.4075 24.0559H38.3047V26.9562H29.4075V24.0559Z" fill="#EBF0F3" />
                <path d="M6.10107 35.5273H40V37.131H6.10107V35.5273Z" fill="#E1E6E9" />
                <path d="M0 35.5318H6.10105V37.1355H0V35.5318Z" fill="#D5D6DB" />
                <path d="M0 15.8486H6.10105V35.5272H0V15.8486Z" fill="#27A2DB" />
                <path d="M6.10089 15.8516C15.8171 15.4579 22.5566 3.71612 32.2621 2.8645C32.2618 9.42363 32.2618 15.9828 32.2621 22.5419C22.5566 23.3933 15.8171 35.1352 6.10089 35.5289C6.10048 28.9698 6.10048 22.4107 6.10089 15.8516Z" fill="#2D93BA" />
            </g>
            <defs>
                <clipPath id="clip0_13_19170">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default ChequeBookIcon;